import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_PLAN_DEFINITIONS from './GetPlanDefinitions.graphql';

export const useGetPlanDefinitions = (options) =>
  useCustomQuery(GET_PLAN_DEFINITIONS, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'getPlanDefinitions',
    ...options,
  });
